$cookies.config('1000d')

export const storage = {
  set(key, value){
    if(storage.isStorageAllowed()){
      $cookies.set(key, JSON.stringify(value));
    }
  },

  get(key, defaultValue){
    try{
        if(!$cookies.isKey(key)){
            return defaultValue
        }
        
        let value = $cookies.get(key);
        if (value && typeof value === 'object')
        {
            // vue-cookies already has paresed object values stored in the cookie.
            return value;
        }
        else
        {
            return JSON.parse(value);
        }
      
    }catch (e){
      return defaultValue;
    }
  },

  has(key){
    return $cookies.isKey(key);
  },

  remove(key){
    return $cookies.remove(key)
  },

  isStorageAllowed(){
    return storage.get("allowCookies");
  },

  allowStorage(){
    return $cookies.set("allowCookies", JSON.stringify(true));
  }
}
